import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const WaterSupplyMainLineJunctionMasterTableDataAPI = createAsyncThunk("WaterSupplyMainLineJunctionMasterTableData", async ({ data }) => {
    const {
        M_WardID,
        M_WS_JunctionID,
        token,
        From,
        To,
        M_UsersID,
        DashProjectTypeId
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Master/Get_WEB_M_WS_Junction_Select?M_WS_JunctionID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_WardID=${M_WardID ?M_WardID : '0'}&M_UserID=${M_UsersID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WaterSupplyMainLineJunctionMasterTableDataSlice = createSlice({
    name: "WaterSupplyMainLineJunctionMasterTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyMainLineJunctionMasterTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterSupplyMainLineJunctionMasterTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WaterSupplyMainLineJunctionMasterTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyMainLineJunctionMasterTableDataReducer = WaterSupplyMainLineJunctionMasterTableDataSlice.reducer


export const WaterSupplyMainLineJunctionMasterPostDataAPI = createAsyncThunk("WaterSupplyMainLineJunctionMasterPostData", async ({ data }) => {
    const {
        M_WS_JunctionID,    
        M_WardID,
        JunctionDetails,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
        DashProjectTypeId
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    formdata.append("M_WS_JunctionID",M_WS_JunctionID);
    formdata.append("M_WardID", M_WardID);
    formdata.append("JunctionDetails", JunctionDetails);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag",Flag);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/Post_WEB_M_WS_Junction_InsertUpdate`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const WaterSupplyMainLineJunctionMasterPostDataSlice = createSlice({
    name: "WaterSupplyMainLineJunctionMasterPostData",
    initialState: {
        isPostLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyMainLineJunctionMasterPostDataAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(WaterSupplyMainLineJunctionMasterPostDataAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WaterSupplyMainLineJunctionMasterPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyMainLineJunctionMasterPostDataReducer = WaterSupplyMainLineJunctionMasterPostDataSlice.reducer

// -----------------Delete API ---------------

export const WaterSupplyMainLineJunctionMasterDeleteAPI = createAsyncThunk("WaterSupplyMainLineJunctionMasterDelete", async ({ data }) => {
    const {
        M_WS_JunctionID,
        M_UserID,
        token,
        handleIsPost,
        DashProjectTypeId,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    formdata.append("M_WS_JunctionID",M_WS_JunctionID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/WEB_M_WS_Junction_Delete?`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const WaterSupplyMainLineJunctionMasterDeleteSlice = createSlice({
    name: "WaterSupplyMainLineJunctionMasterDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyMainLineJunctionMasterDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(WaterSupplyMainLineJunctionMasterDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(WaterSupplyMainLineJunctionMasterDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyMainLineJunctionMasterDeleteReducer = WaterSupplyMainLineJunctionMasterDeleteSlice.reducer